/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "DeletedViewBoxService";
const log: any = LoggerModule.getInstance();

export class DeletedViewBoxService {
  private static instance: DeletedViewBoxService;
  private vapp: VApplication;
  private boxDetails: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): DeletedViewBoxService {
    if (!DeletedViewBoxService.instance) {
      DeletedViewBoxService.instance =
        new DeletedViewBoxService(props);
    }
    return DeletedViewBoxService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getBoxDetails() {
    return this.boxDetails;
  }
  private setBoxDetails(data: any) {
    this.boxDetails = data;
  }

  public async getBoxes(arg: any) {
    console.log("dsadsadsadas------>>2222")
    let content: any = {};
    const agent = getAgent();
    content = await agent.getBoxes(arg);
    this.setBoxDetails(content?.data);
    return content;
  }

  public async undoDeleteBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.undoDeleteBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
